import { map } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UsuarioService } from "src/app/components/usuario/service/usuario.service";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate {

  constructor(private usuarioService: UsuarioService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.usuarioService.retornaUser().pipe(
      map((usuario) => {
        if (usuario.perfil.toString() === "0") {
          this.router.navigate(['/']);
          return false;
        }
        return true;
      }));
  }

}
